import React from 'react';
const departments = [
  {
    name: 'Computer Science',
    description: 'Explore cutting-edge technology and software development.',
    programs: ['BSc Computer Science', 'MSc Data Science', 'PhD in CS'],
    head: 'Dr. Sarah Johnson',
    email: 'cs@university.edu'
  },
  {
    name: 'Business Administration',
    description: 'Develop leadership and management skills for the business world.',
    programs: ['BBA', 'MBA', 'Executive MBA'],
    head: 'Dr. Michael Chen',
    email: 'business@university.edu'
  },
  {
    name: 'Engineering',
    description: 'Innovative programs in various engineering disciplines.',
    programs: ['Civil', 'Mechanical', 'Electrical', 'Biomedical'],
    head: 'Dr. Emily Rodriguez',
    email: 'engineering@university.edu'
  },
  {
    name: 'Health Sciences',
    description: 'Preparing the next generation of healthcare professionals.',
    programs: ['Nursing', 'Public Health', 'Health Administration'],
    head: 'Dr. James Wilson',
    email: 'health@university.edu'
  },
  {
    name: 'Liberal Arts',
    description: 'Fostering critical thinking and creative expression.',
    programs: ['English', 'History', 'Philosophy', 'Political Science'],
    head: 'Dr. Jennifer Lee',
    email: 'liberalarts@university.edu'
  },
  {
    name: 'Natural Sciences',
    description: 'Advancing scientific knowledge and research.',
    programs: ['Biology', 'Chemistry', 'Physics', 'Environmental Science'],
    head: 'Dr. Robert Taylor',
    email: 'sciences@university.edu'
  }
];

const Departments = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Academic Departments</h1>
          <div className="w-24 h-1 bg-primary mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto">
            Explore our diverse range of academic departments and find your area of study.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {departments.map((dept, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="p-6">
                <h2 className="text-2xl font-semibold text-gray-800 mb-2">{dept.name}</h2>
                <p className="text-gray-600 mb-4">{dept.description}</p>
                
                <div className="mb-4">
                  <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2">Programs</h3>
                  <ul className="space-y-1">
                    {dept.programs.map((program, i) => (
                      <li key={i} className="text-sm text-gray-600 flex items-center">
                        <span className="text-primary mr-2">•</span>
                        {program}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="pt-4 border-t border-gray-100">
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Department Head:</span> {dept.head}
                  </p>
                  <a 
                    href={`mailto:${dept.email}`} 
                    className="text-primary hover:underline text-sm inline-block mt-1"
                  >
                    {dept.email}
                  </a>
                </div>
              </div>
              <div className="bg-gray-50 px-6 py-3 text-right">
                <button className="text-primary hover:text-yellow-600 text-sm font-medium">
                  View Department →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      
    </div>
  );
};

export default Departments;
